import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const selectInitialShowcase = state => state.collection.initialShowcase;
const selectCollectionOrder = state => state.collection.collectionOrder;
const selectCollectionPanels = state => state.collection.panels;
const selectVisibleCollections = state => state.collection.visibleCollections;
const selectPanelPanels = state => state.panel.panels;
const selectGlobalVideoPanelVideo = state => state.globalVideo.panelVideo;

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

export const makeSelectInitialShowcase = createDeepEqualSelector(
  selectInitialShowcase,
  initialShowcase => initialShowcase,
);

export const makeSelectCollectionOrder = createDeepEqualSelector(
  selectCollectionOrder,
  collectionOrder => collectionOrder,
);

export const makeSelectCollectionPanels = createDeepEqualSelector(
  selectCollectionPanels,
  panels => panels,
);

export const makeSelectVisibleCollections = createDeepEqualSelector(
  selectVisibleCollections,
  visibleCollections => visibleCollections,
);

export const makeSelectPanelPanels = createDeepEqualSelector(selectPanelPanels, panels => panels);

export const makeSelectGlobalVideoPanelVideo = createDeepEqualSelector(
  selectGlobalVideoPanelVideo,
  panelVideo => panelVideo,
);
